import styled from "styled-components";
import { ReactComponent as AppStore } from "../../assets/icons/app-store.svg";
import { ReactComponent as GooglePlay } from "../../assets/icons/google-play.svg";
import { ReactComponent as Chrome } from "../../assets/icons/chrome.svg";

export const AppStoreSvg = styled(AppStore)`
  cursor: pointer;
  height: 240px;
  width: 240px;
  @media (max-width: 768px) {
    height: 140px;
    width: 140px;
  }
`;

export const GooglePlaySvg = styled(GooglePlay)`
  cursor: pointer;
  height: 240px;
  width: 240px;
  @media (max-width: 768px) {
    height: 140px;
    width: 140px;
  }
`;

export const ChromeSvg = styled(Chrome)`
  cursor: pointer;
  height: 240px;
  width: 240px;
  @media (max-width: 768px) {
    height: 140px;
    width: 140px;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
`;

export const Text = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: ${(props) => (props.$bold ? "800" : "500")};
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.08px;
  text-decoration: ${(props) => (props.$link ? "underline" : "none")};
  cursor: ${(props) => (props.$link ? "pointer" : "default")};
  &:hover {
    opacity: ${(props) => (props.$link ? ".85" : "1")};
  }
`;

export const List = styled.ol``;
export const ListItem = styled.li`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.08px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  max-width: 970px;
  width: 100%;
  margin: 0 auto;
`;

export const TextContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  max-width: ${(props) => (props.$small ? "300px" : "380px")};
  height: auto;
  user-select: none;
  object-fit: cover;
  border-radius: 24px;
  background-color: #0a1a2f;
`;

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  aspect-ratio: 16/9;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  background: #000;
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
`;
